var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 107,
    viewBox: "0 0 144 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_3508_2792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6655 76.3849C28.4008 94.324 56.9431 103.803 82.7288 105.465C90.2018 105.944 97.7399 105.734 105.124 104.499L115.004 74.1088C88.73 78.4738 59.2525 71.4285 36.9228 58.4309C30.8891 54.9194 25.2376 50.824 20.4154 45.9648L10.6655 76.3849V76.3849Z",
    stroke: "url(#paint0_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6863 31.1545C15.26 33.4081 -5.18311 43.7178 1.51742 62.7425C3.32266 67.8562 6.77864 72.4308 10.6575 76.384L20.4074 45.9639C7.53488 32.9064 5.5426 14.9299 24.2618 5.81063C29.8646 3.08532 36.1666 1.62534 42.4118 0.824219L32.6782 31.1545H32.6863Z",
    stroke: "url(#paint1_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.412 62.3957L125.575 61.4448L135.439 31.1445C153.312 50.8356 140.009 69.8903 115.004 74.113L105.124 104.503C129.258 100.4 143.391 82.0867 126.412 62.3957Z",
    stroke: "url(#paint2_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.575 61.4424C108.84 43.0391 80.6225 33.2909 55.2922 30.9325C47.7785 30.2287 40.1753 30.2137 32.686 31.1571L42.4197 0.826892C68.7258 -2.47492 97.8536 4.83249 119.728 18.4216C125.526 22.0229 130.925 26.2007 135.43 31.1421L125.567 61.4424H125.575Z",
    stroke: "url(#paint3_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3115 95.0787C49.1209 91.6047 21.5787 81.4223 16.6265 62.5847C14.927 56.1309 17.4072 49.9315 23.1319 45.911L32.8656 15.5508C10.479 31.2138 42.9733 52.9863 57.521 58.9011C63.8068 61.4617 70.4016 63.3859 77.1346 64.6736L67.3034 95.0787H67.3115Z",
    stroke: "url(#paint4_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.49 61.5275L111.19 62.2537L121.037 31.9385C104.489 14.6059 73.3611 5.84596 48.9334 9.72427C43.2331 10.6302 37.5409 12.2998 32.8814 15.5492L23.1477 45.9094C42.4199 32.4701 74.9874 40.2117 94.0481 49.9599C100.098 53.0521 105.807 56.8256 110.499 61.535L110.49 61.5275Z",
    stroke: "url(#paint5_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.19 62.2531C129.177 81.1805 108.913 95.8776 87.5674 96.7237C80.7856 96.9932 73.9549 96.3418 67.3113 95.084L77.1425 64.6789C92.6985 67.6363 133.65 68.1529 128.047 43.6701C127.039 39.2827 124.209 35.2696 121.038 31.9453L111.19 62.2606V62.2531Z",
    stroke: "url(#paint6_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.438 31.1447C118.825 12.9212 90.9498 3.21787 65.8553 0.702207C48.3315 -1.05726 17.6668 -0.0465021 10.9012 19.083C4.11119 38.2949 28.9861 54.9687 44.4851 62.4333C67.0425 73.2896 96.7396 79.6237 121.72 72.6382C144.082 66.3865 150.572 47.811 135.438 31.1447V31.1447Z",
    stroke: "url(#paint7_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.697 60.4942C137.211 73.6715 138.187 91.2736 119.834 100.086C97.5367 110.8 67.1729 105.544 45.0465 97.2633C27.2299 90.5923 -0.214667 75.985 0.167523 55.2158C0.541582 35.2926 28.1488 30.3886 44.9408 30.426C73.1253 30.4784 105.717 40.5785 124.697 60.5017V60.4942Z",
    stroke: "url(#paint8_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.037 31.9377C133.178 44.6732 128.299 59.7447 110.702 64.4841C93.4139 69.141 73.3367 65.39 57.244 58.7864C44.4447 53.5304 24.8229 42.3597 25.7906 27.1908C26.8802 10.2101 52.3894 8.17361 66.0588 9.16939C85.762 10.6069 107.718 17.9817 121.037 31.9377V31.9377Z",
    stroke: "url(#paint9_linear_3508_2792)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.857 62.9785C100.334 50.2803 81.6396 43.1676 64.3028 40.4273C50.3813 38.2261 28.1898 37.5448 18.9766 49.8461C8.10449 64.3636 28.1248 79.6223 40.2654 85.8965C56.0897 94.0724 75.8417 98.6245 93.9673 96.1912C113.296 93.6007 126.307 78.9185 111.857 62.9785V62.9785Z",
    stroke: "url(#paint10_linear_3508_2792)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3508_2792",
    x1: 10.2102,
    y1: 75.6437,
    x2: 115.581,
    y2: 75.6437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3508_2792",
    x1: -0.190238,
    y1: 38.7539,
    x2: 42.9892,
    y2: 38.7539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3508_2792",
    x1: 104.538,
    y1: 67.6741,
    x2: 144.066,
    y2: 67.6741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3508_2792",
    x1: 32.1168,
    y1: 30.94,
    x2: 135.886,
    y2: 30.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3508_2792",
    x1: 15.6995,
    y1: 55.0377,
    x2: 77.6551,
    y2: 55.0377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3508_2792",
    x1: 22.3996,
    y1: 35.7195,
    x2: 121.485,
    y2: 35.7195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3508_2792",
    x1: 66.799,
    y1: 64.1698,
    x2: 128.974,
    y2: 64.1698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3508_2792",
    x1: 9.33988,
    y1: 37.8307,
    x2: 144.05,
    y2: 37.8307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3508_2792",
    x1: -0.247194,
    y1: 68.2658,
    x2: 134.292,
    y2: 68.2658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3508_2792",
    x1: 25.3515,
    y1: 37.7551,
    x2: 128.144,
    y2: 37.7551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3508_2792",
    x1: 15.4474,
    y1: 67.9948,
    x2: 118.428,
    y2: 67.9948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC01F",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC01F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_2792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.494,
    height: 106.067,
    fill: "white",
    transform: "translate(0.163574 0.0390625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/frame2.433ab1e8f23a86e1488188fe5a5a1152.svg";
export { ForwardRef as ReactComponent };